// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarArquivosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract das duas portas de escrita/leitura da E10
 * (controllers/migration/arquivos.php).
 *
 * A MESMA validação serve o progresso e a carga: as duas recusam o mesmo pedido
 * malformado com a mesma mensagem. O progresso ignora `limite`.
 */
import { registerContract } from './validate'

export interface Migration_MigrarArquivosInput {
zoho_id_unidade?: string
limite?: number
}

registerContract('Migration_MigrarArquivosInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  limite:          { type: 'number',  required: false },
})
